import React, { useEffect } from "react";
import dayjs from 'dayjs';

import { Card, Grid } from "@mui/material";

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { loadApplicableHolidaysFromBackend } from "app/services/holiday.service";
import { getCurrentYearEndDate, getCurrentYearStartDate } from "utils/dateUtil";
import { handleAxiosError } from "app/services/app.error.handler";
import { HolidayDataGridBase } from "app/components/leave-plans/HolidayDataGridBase";

import "./leave-plans.css";
import { useDispatch, useSelector } from "react-redux";
import { holidayActions } from "store/holiday-slice";

export const HolidayListView = () => {
    const [fromDate, setFromDate] = React.useState(dayjs(getCurrentYearStartDate()));
    const [toDate, setToDate] = React.useState(dayjs(getCurrentYearEndDate()));
    const dispatch = useDispatch();
    const holidayData = useSelector((state) => state.holiday.rows);

    useEffect(() =>  {
            if(holidayData.length === 0)
                getHolidayListFromBackend(fromDate, toDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [fromDate, toDate]);

    const getHolidayListFromBackend = async (fromDate, toDate) => {
        await loadApplicableHolidaysFromBackend(fromDate, toDate)
        .then(response => { 
            dispatch(holidayActions.replaceData(response.status === 204 ? [] : response.data));
        })
        .catch(error=>{
            dispatch(holidayActions.replaceData([]));  // Set the empty data in holidays table
            handleAxiosError(error);
        });
    };

    return (
            <Grid item xs={12} sm={12} md={12}>
                <Card>
                    <MDBox
                        mx={2}
                        mt={-3}
                        py={1}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                    >
                        <MDTypography variant="h6" color="white">
                            InOpTra Holidays
                        </MDTypography>
                    </MDBox>

                    <HolidayDataGridBase holidayData={holidayData}/>
                    
                </Card>
                
            </Grid>
        );
}